import { useStoreHeaderHeight } from '@core/context';
import { HeaderHeightHook, HeaderHeightState, HookStoreFn } from '@core/type/context';

export const useHeaderHeight: HookStoreFn<HeaderHeightState, HeaderHeightHook> = () => {
  const [height, setHeight] = useStoreHeaderHeight<string>('height');
  return { height, setHeight };
};
